const FaqUnic = () => {
  const faqs = [
    {
      question: '¿Qué es la Ventanilla Única Digital?',
      answer:
        'Es una herramienta del gobierno para centralizar el registro de alojamientos de alquiler turístico y temporal, y facilitar la comunicación con plataformas online como Airbnb o Booking.',
    },
    {
      question: '¿Quién tiene que registrarse?',
      answer:
        'Cualquier persona o empresa que alquile una vivienda para uso turístico o temporal en España, a través de plataformas digitales, debe registrarla en la Ventanilla Única a partir de julio de 2025.',
    },
    {
      question: '¿Qué datos hay que aportar?',
      answer:
        'Se solicita información básica como nombre del titular, dirección y referencia catastral del inmueble, tipo de alquiler, y en su caso el número de registro autonómico si ya se dispone de él.',
    },
    {
      question: '¿Tengo que registrarme si ya estoy en el registro autonómico?',
      answer:
        'Sí. Aunque tu vivienda ya esté registrada a nivel autonómico, también deberás registrarla en el sistema estatal para que las plataformas de alquiler puedan verificar tu legalidad.',
    },
    {
      question: '¿Qué pasa si no registro mi vivienda?',
      answer:
        'Podrías recibir sanciones por incumplimiento y las plataformas podrían desactivar tu anuncio. Es obligatorio para seguir alquilando de forma legal.',
    },
    {
      question: '¿Cómo se hace el registro?',
      answer:
        'El trámite se realiza online a través del portal del Ministerio de Vivienda (www.mivau.gob.es). Winahost te puede acompañar durante el proceso, sin coste.',
    },
    {
      question: '¿Cuándo entra en vigor esta obligación?',
      answer:
        'Desde el 1 de julio de 2025. A partir de esa fecha será obligatorio para todas las propiedades ofertadas en plataformas online.',
    },
  ];

  return (
    <section style={{ padding: '80px 20px', backgroundColor: '#fff' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', color: '#1a237e', marginBottom: '48px' }}>
          Preguntas frecuentes
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {faqs.map((faq, index) => (
            <details
              key={index}
              style={{
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                padding: '20px 24px',
                backgroundColor: '#fafafa',
                fontFamily: 'inherit',
              }}
            >
              <summary
                style={{
                  fontSize: '1.1rem',
                  fontWeight: '600',
                  color: '#1a237e',
                  cursor: 'pointer',
                  listStyle: 'none',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                {faq.question}
                <span style={{ fontSize: '1.2rem', transform: 'rotate(0deg)', transition: 'transform 0.2s ease' }}>⌄</span>
              </summary>
              <p style={{
                fontSize: '1rem',
                color: '#444',
                marginTop: '16px',
                lineHeight: '1.6',
              }}>
                {faq.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqUnic;
